// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__1PRDw","active":"Tabs_active__9s_sI","disabled":"Tabs_disabled__1whWf","activeTab":"Tabs_activeTab__2s1PF"};